
import React from 'react';
import UpscaleIcon from './UpscaleIcon';
import InpaintIcon from './InpaintIcon';
import FaceIcon from './FaceIcon';
import DressIcon from './DressIcon';
import ColorsIcon from './ColorsIcon';

export type ImageActionType = 
  | 'upscale' 
  | 'inpaint' 
  | 'change-face' 
  | 'change-dress' 
  | 'change-colors';

interface ImageActionToolbarProps {
  onAction: (action: ImageActionType, label: string) => void; 
  disabled?: boolean;
  onDebugHover?: (name: string | null) => void; // New prop
}

const ImageActionToolbar: React.FC<ImageActionToolbarProps> = ({ onAction, disabled, onDebugHover }) => {
  const actions = [
    { type: 'upscale', icon: <UpscaleIcon />, label: 'Mejorar Resolución (Upscale)', colorClassName: 'text-sky-400' },
    { type: 'inpaint', icon: <InpaintIcon />, label: 'Rellenar/Eliminar (Inpaint)', colorClassName: 'text-emerald-400' },
    { type: 'change-face', icon: <FaceIcon />, label: 'Cambiar Cara', colorClassName: 'text-amber-400' },
    { type: 'change-dress', icon: <DressIcon />, label: 'Cambiar Vestimenta', colorClassName: 'text-fuchsia-400' },
    { type: 'change-colors', icon: <ColorsIcon />, label: 'Ajustar Colores', colorClassName: 'text-teal-400' },
  ];

  return (
    <div className="flex flex-col space-y-1 p-1 bg-slate-800 bg-opacity-85 rounded-lg shadow-lg ring-1 ring-slate-600">
      {actions.map(actionDef => (
        <button
          key={actionDef.type}
          onClick={() => onAction(actionDef.type as ImageActionType, actionDef.label)} 
          onMouseEnter={() => onDebugHover?.(`Toolbar Action: ${actionDef.label}`)}
          onMouseLeave={() => onDebugHover?.(null)}
          disabled={disabled}
          className="p-2 group rounded-md transition-colors focus:outline-none focus:ring-1 focus:ring-indigo-400 disabled:opacity-40 disabled:cursor-not-allowed"
          aria-label={actionDef.label}
          title={actionDef.label}
        >
          {React.cloneElement(actionDef.icon, { 
            className: `w-6 h-6 ${actionDef.colorClassName} group-hover:opacity-80 transition-opacity` 
          })}
        </button>
      ))}
    </div>
  );
};

export default ImageActionToolbar;
